(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beam-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('beam-reviews-carousel')) {
    class BeamReviewsCarousel extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('click', event => {
          if (event.target.closest('[data-review-more]')) this.showMore();
          if (event.target.closest('[data-review-prev]')) this.move(-1);
          if (event.target.closest('[data-review-next]')) this.move(1);
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards?.find(item => item.dataset.blockId === event.detail?.blockId);
          if (!card) return;
          const index = this.cards.indexOf(card);
          this.visibleCount = Math.max(this.visibleCount, index + 1);
          this.update();
          card.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
        }, { signal });
        window.addEventListener('resize', () => this.updateArrows(), { passive: true, signal });
        this.domObserver = new MutationObserver(() => this.setup());
        this.domObserver.observe(this, { childList: true, subtree: true });
        this.setup();
      }
      setup() {
        const track = this.querySelector('[data-review-track]');
        const cards = [...this.querySelectorAll('[data-review-card]')];
        if (!track || !cards.length || !this.querySelector('[data-review-more]')) return;
        if (track === this.track && cards.length === this.cards?.length && cards.every((card,index) => card === this.cards[index])) return;
        this.trackController?.abort();
        this.trackController = new AbortController();
        this.track = track;
        this.cards = cards;
        this.visibleCount = Math.min(cards.length, Math.max(1, Number(this.dataset.initial) || 10));
        this.batch = Math.max(1, Number(this.dataset.batch) || 10);
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateArrows(); });
        }, { passive: true, signal: this.trackController.signal });
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.track);
        this.cards.forEach(card => this.resizeObserver.observe(card));
        this.querySelector('[data-review-controls]').hidden = false;
        this.update();
      }
      get behavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      update() {
        if (!this.cards) return;
        this.cards.forEach((card,index) => { card.hidden = index >= this.visibleCount; });
        this.querySelector('[data-review-more]').hidden = this.visibleCount >= this.cards.length;
        const count = this.querySelector('[data-review-count]');
        const label = (this.dataset.countLabel || '').replaceAll('{shown}', this.visibleCount).replaceAll('{total}', this.cards.length);
        if (count.textContent !== label) count.textContent = label;
        this.updateArrows();
      }
      showMore() {
        if (!this.cards || this.visibleCount >= this.cards.length) return;
        const firstNew = this.cards[this.visibleCount];
        this.visibleCount = Math.min(this.cards.length, this.visibleCount + this.batch);
        this.update();
        firstNew.focus({ preventScroll: true });
        firstNew.scrollIntoView({ block: 'nearest', inline: 'start', behavior: this.behavior });
      }
      move(direction) {
        if (!this.track || !this.cards?.length) return;
        const step = this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        this.track.scrollBy({ left: direction * step, behavior: this.behavior });
      }
      updateArrows() {
        if (!this.track) return;
        const bounds = this.track.getBoundingClientRect();
        let height = 0;
        for (const card of this.cards) {
          if (card.hidden) continue;
          const rect = card.getBoundingClientRect();
          if (rect.right > bounds.left + 1 && rect.left < bounds.right - 1) height = Math.max(height, rect.height);
        }
        if (height > 0) {
          const style = getComputedStyle(this.track);
          const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
          const scrollbar = this.track.offsetHeight - this.track.clientHeight;
          const desired = Math.ceil(height + padding + scrollbar) + 'px';
          if (this.track.style.height !== desired) this.track.style.height = desired;
        }
        const previous = this.querySelector('[data-review-prev]');
        const next = this.querySelector('[data-review-next]');
        if (previous) previous.disabled = this.track.scrollLeft <= 1;
        if (next) next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.trackController?.abort();
        this.domObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.track = null;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
    }
    customElements.define('beam-reviews-carousel', BeamReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
